// extracted by mini-css-extract-plugin
export default {"board_image":"CardImage_board_image__7-hX2","web_board_image":"CardImage_web_board_image__1gut3"};